export default class SDRateGainWorksheet {
  l7 = (): number | undefined => undefined
  l10 = (): number | undefined => undefined
  l13 = (): number | undefined => undefined
  l14 = (): number | undefined => undefined
  l21 = (): number | undefined => undefined
}
